import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const success = (msg) => {
  toast.success(msg);
}

const error = (msg) => {
  toast.error(msg);
}

const warn = (msg) => {
  toast.warn(msg);
}

export { success, error, warn }
